import * as R from 'ramda'

export function cleanDraft (rawDraft) {
  try {
    const elementTypes = ['categories', 'groups', 'items', 'questions', 'options', 'questions', 'options']

    const identicalElementsDraft = R.clone(rawDraft) // 在這個裡面的 element 都會是獨一無二的

    const identicalElementTable = {} // key: 被刪掉的 item 的 id, value: 跟他一樣的 item 的 id

    // 這個迴圈目的在把重複的 Elements 刪掉
    // questions 跟 options 要跑兩次，因為有可能因為第一次的化簡而產生出重複的 elements
    R.aperture(2, elementTypes).reverse().forEach(([parentType, elementType]) => {
      // 要先找到一樣的 elements，並把它的 id 放到 identicalElementTable 裡面
      // 並把不一樣的 elements 放到 identicalElementsDraft 裡面
      identicalElementsDraft[elementType] = Object.keys(identicalElementsDraft[elementType]).reduce((cleanElements, eid) => {
        const identicalElementId = Object.keys(cleanElements).find(k => {
          const { id: id1, new: new1, storeId: storeId1, ...cleanElementProps } = cleanElements[k]
          const { id: id2, new: new2, storeId: storeId2, ...cleanDraftElementProps } = identicalElementsDraft[elementType][eid]
          return R.equals(cleanElementProps, cleanDraftElementProps)
        })
        if (!identicalElementId || elementType === 'groups' || elementType === 'items') { // 沒有找到一樣的 或 elementType為groups（group不該被合併）
          cleanElements[eid] = Object.assign({}, identicalElementsDraft[elementType][eid])
        } else { // 有重複的
          identicalElementTable[eid] = identicalElementId
        }
        return cleanElements
      }, {})

      // 把 identicalElementsDraft 裡 parents 的 childs 中已經在前一個步驟裡被刪掉的 ids 利用 table map 到同一個
      const parents = {}
      Object.keys(identicalElementsDraft[parentType]).forEach(parentId => {
        parents[parentId] = Object.assign({}, identicalElementsDraft[parentType][parentId])
        parents[parentId][elementType] = identicalElementsDraft[parentType][parentId][elementType].map(id => identicalElementTable[id] || id)
        parents[parentId].defaultValue = identicalElementsDraft[parentType][parentId].defaultValue
          ? identicalElementsDraft[parentType][parentId].defaultValue instanceof Array
            ? identicalElementsDraft[parentType][parentId].defaultValue.map(id => identicalElementTable[id] || id)
            : identicalElementTable[identicalElementsDraft[parentType][parentId].defaultValue] ||
              identicalElementsDraft[parentType][parentId].defaultValue
          : null
      })
      identicalElementsDraft[parentType] = parents
    })

    // 裡面儲存的 elements 都是沒有重複且都有被 reference 到的
    const draft = {
      categories: Object.assign({}, identicalElementsDraft.categories),
      groups: {},
      items: {},
      questions: {},
      options: {}
    }

    // 這個迴圈在把沒有被指到的 children 刪掉
    // 一層一層從 draft 的 categories 建立下來
    // 讀取 draft 的資料，再從 identicalElementsDraft 裡面抓下一層需要的資料
    R.aperture(2, elementTypes).forEach(([elementType, childType]) => {
      Object.assign(draft[childType], Object.keys(draft[elementType]).reduce((children, eid) =>
        Object.assign(children, draft[elementType][eid][childType].reduce((cleanChildren, cid) =>
          R.assoc(cid, identicalElementsDraft[childType][cid], cleanChildren), {})), {}))
    })

    return { draft, identicalElementTable }
  } catch (e) {
    console.error('cleanDraft: ' + e.message)
    throw e
  }
}
